import { render, staticRenderFns } from "./DrillCard.vue?vue&type=template&id=331cc2c3"
import script from "./DrillCard.vue?vue&type=script&lang=js"
export * from "./DrillCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports